import AntdDropdown from 'antd/lib/dropdown';
import type { MenuProps as AntMenuProps } from 'antd/lib/menu';

export const Dropdown = AntdDropdown;
export type MenuProps = AntMenuProps;
